// extracted by mini-css-extract-plugin
module.exports = {"weeklyUpdatesList":"weekly-updates-list_weeklyUpdatesList__3j4DI"};